<template>
  <b-tab>
    <template slot="title">
      <div :class="slot_name_assoc[slot_name]" class="tab-sprite"></div>
    </template>
    <slot></slot>
  </b-tab>
</template>

<script>
var slot_name_assoc = {
  'Body': 'body',
  'Decal': 'decal',
  'Paint Finish': 'paint',
  'Wheels': 'wheels',
  'Rocket Boost': 'boost',
  'Topper': 'topper',
  'Antenna': 'antenna',
  'Trail': 'trail',
  'Goal Explosion': 'goalexplosion',
  'Map': 'map'
}

export default {
  data() {
    return {
      slot_name_assoc
    }
  },
  props: {
    slot_name: String
  }
}
</script>

<style scoped>
.body {
  background-position: 0 11.111111%;
}

.decal {
  background-position: 0 77.777778%;
}

.paint {
  background-position: 0 66.666667%;
}

.wheels {
  background-position: 0 100%;
}

.boost {
  background-position: 0 22.222222%;
}

.topper {
  background-position: 0 44.444444%;
}

.antenna {
  background-position: 0 0%;
}

.trail {
  background-position: 0 88.888889%;
}

.goalexplosion {
  background-position: 0 33.333333%;
}

.map {
  background-position: 0 55.555556%;
}

.tab-sprite {
  width: 32px;
  height: 32px;
  background-image: url('../assets/img/sprites/tabs.png'); /* Responsive spritesheet + CSS generated with https://responsive-css.spritegen.com/ */
  background-size: 100%;
}
</style>